import React, { useEffect, useState } from 'react'
import TitleHeader from '../../../../../../smallComponents/Header'
import TaskRequestDetails from './DepTaskRequestsComponents/TaskRequestDetails'
import ExpandedCardsSystem from '../../../../../../expandedCardsSystem/ExpandedCardsSystem'
import axios from 'axios'
import CustomCircularProgress from '../../../../../../smallComponents/CustomCircularProgress'
import MultiLangNumber from '../../../../../../smallComponents/MultiLangNumber'
import { useTranslation } from 'react-i18next'

const DepTaskRequests = ({ task, DCGProps }) => {
  const { project } = DCGProps
  const [requests, setRequests] = useState([])
  const [requestsUsers, setRequestsUsers] = useState([])
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    const fetchRequests = async () => {
      setIsLoading(true)
      try {
        const res = await axios.get(`/requests/elementRequests/${task?._id}`)
        setRequests(res.data.requests)
        setRequestsUsers(res.data.requestsUsers)
      } catch (error) {
        console.log(error)
      }
      setIsLoading(false)
    }
    fetchRequests()
  }, [project?._id])

  return isLoading ? (
    <CustomCircularProgress />
  ) : (
    <span>
      <TitleHeader
        headerText={`${MultiLangNumber(requests?.length)} ${t('Requests')}`}
      />
      <ExpandedCardsSystem
        cards={requests}
        UnitCardDetailsComponent={TaskRequestDetails}
        firsButtonConfigs={{
          hideButton: true,
          props: { task },
        }}
        searchSystemProps={{}}
        DCGProps={DCGProps}
        requestsUsers={requestsUsers}
        setRequests={setRequests}
      />
    </span>
  )
}

export default DepTaskRequests
